import { Css, useComputed } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { useConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { BasePlanSection } from "src/routes/bids/plan-based-bid-package/components/BasePlanSection";
import { OptionsSection } from "src/routes/bids/plan-based-bid-package/components/OptionsSection";
import { PlanBasedBidPackageFormState } from "src/routes/bids/plan-based-bid-package/utils";
import { queryResult } from "src/utils";

type ConfigureBidGroupsStepProps = { formState: ObjectState<PlanBasedBidPackageFormState> };

export function ConfigureBidGroupsStep(props: ConfigureBidGroupsStepProps) {
  const { formState } = props;
  const productOfferingIds = useComputed(() => formState.productOfferings.value ?? [], [formState.productOfferings]);
  const bidPackageId = useComputed(() => formState.bidPackageId.value ?? "", [formState.bidPackageId]);
  const query = useConfigureBidGroupsStepQuery({
    variables: { bidPackageId, productOfferingIds },
    skip: !bidPackageId || productOfferingIds.isEmpty,
  });

  return (
    <div css={Css.df.fdc.aic.$}>
      <div css={Css.df.fdc.aic.my6.$}>
        <div css={Css.xl2.$}>Configure Bid Groups</div>
        <div css={Css.md.pt2.$}>For your selected product offerings, choose what to include as lines in this bid.</div>
      </div>
      <div css={Css.w50.p4.bgWhite.bshBasic.br12.mb3.$}>
        {productOfferingIds.isEmpty
          ? "Select at least one product offering in step 1 to configure bid groups."
          : queryResult(query, (data) => (
              <>
                <BasePlanSection
                  formState={formState}
                  dimensionResults={data.potentialBidPlanDimensions}
                  productOfferings={data.bidPackage.productOfferings}
                />
                <OptionsSection
                  formState={formState}
                  dimensionResults={data.potentialBidPlanDimensions}
                  potentialBidPlanOptions={data.bidPackage.potentialBidPlanOptions}
                />
              </>
            ))}
      </div>
    </div>
  );
}
